
import { z } from "zod";

export const FinancingVendorValues = ["GOODLEAP", "SUNLIGHT", "UPGRADE"] as const;
export const FinancingVendorSchema = /* @__PURE__ */ z.enum(FinancingVendorValues);
export const FinancingVendor: (typeof FinancingVendorSchema)["enum"] = { "GOODLEAP": "GOODLEAP", "SUNLIGHT": "SUNLIGHT", "UPGRADE": "UPGRADE" };
export type FinancingVendor = (typeof FinancingVendorValues)[number];
export const FinancingVendorDisplayNames = { "GOODLEAP": "Goodleap Financial",
"SUNLIGHT": "Sunlight Financial",
"UPGRADE": "Upgrade Financial", } satisfies Record<FinancingVendor, string>;
